export default __webpack_public_path__ + "static/media/v2_264.76e886df.png";